import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-update-version',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './update-version.component.html',
  styleUrl: './update-version.component.scss'
})
export class UpdateVersionComponent {
  constructor(private dialogRef: MatDialogRef<UpdateVersionComponent>) {}

  onConfirm(): void {
    this.dialogRef.close(true); // Return true when the user confirms
  }

  onCancel(): void {
    this.dialogRef.close(false); // Return false when the user cancels
  }
}
